<template>
  <div class="base-footer">
    <div style="background: url('https://cdn.steamdt.com/new-index/footer/bg2x.webp') no-repeat; background-position: center">
      <div class="py-30">
        <div class="wrapper">
          <div class="mb-30 text-16 font-semibold text-white">{{ $t('关键特性和工具') }}</div>
          <div class="flex justify-between">
            <a v-for="attr in mainAttr" :key="attr.title" :href="attr.link">
              <div class="group flex cursor-pointer items-center gap-10">
                <div>
                  <img :src="attr.img" alt="" />
                </div>
                <div>
                  <div class="title mb-10 text-20 font-medium text-white group-hover:underline">{{ attr.title }}</div>
                  <div class="text-gray-light">{{ attr.desc }}</div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="footer-banner">
        <el-row class="wrapper h-310 border-t border-[#3D3D48] pt-33" justify="space-between">
          <div>
            <p class="mb-50 text-28 font-[300] text-white">SteamDT - {{ $t('让数字资产分析更加便捷') }}</p>
            <!-- <p class="mt-12 text-white/60">
                SteamDT is a hobbyist project, not affiliated with Valve or Steam. Steam and the Steam logo are trademarks of Valve Corporation.
                All other trademarks are the property of their respective owners.
              </p>
              <p class="mt-12 text-white/60">
                Some of the tools on this website are integrated by the webmaster from existing online tools, opensource packages, etc., and are
                all released under the original licenses, with the copyright belonging to the original authors or teams.
              </p> -->
            <div class="flex text-16">
              <div class="mr-90">
                <div class="title mb-16 text-white">{{ $t('条款') }}</div>
                <div class="content text-color-lightgray">
                  <!-- <div class="mb-10">Terms of Use</div> -->

                  <div>
                    <a :href="localePath(`/terms/PrivacyPolicy`)">{{ $t('隐私政策') }}</a>
                  </div>
                </div>
              </div>
              <div class="mr-90">
                <div class="title mb-16 text-white">SteamDT</div>
                <div class="content text-color-lightgray">
                  <div class="mb-10">
                    <a :href="localePath('/terms/Disclaimer')">{{ $t('免责声明') }}</a>
                  </div>
                  <div class="mb-10">
                    <a :href="localePath('/terms/AboutUs')">{{ $t('关于我们') }}</a>
                  </div>
<!--                  <div class="mb-10"><a :href="localePath('/faq')">FAQ</a></div>-->
                </div>
              </div>
              <div class="mr-90">
                <div class="title mb-16 text-white">{{ $t('联系方式') }}</div>
                <div class="content text-color-lightgray">
                  <div class="mb-10">Email:bd@steamdt.com</div>
                  <div>{{ $t('QQ群') }}: 884816621</div>
                </div>
              </div>
              <div class="mr-90">
                <div class="title mb-16 text-white">{{ $t('公司信息') }}</div>
                <div class="content text-color-lightgray">
                  <div class="mb-10">{{ $t('注册地址') }}</div>
                  <div>{{ $t('我们会在12个小时内回复你的消息') }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- <img src="~/assets/images/footer-good.png" alt="" /> -->
        </el-row>
      </div>
    </div>

    <div class="footer-data text-color-lightgray flex items-center">
      <div>
        <img class="mr-21" src="~/assets/images/common/black-logo.svg" alt="" />
      </div>
      <div>
        <div>

          <div class="flex items-center">
            Powered by
            <img class="mx-5 inline-block leading-none" src="~/assets/images/layouts/img-steam-logo.svg" alt="" />
            {{ $t('本产品与Valve Corporation及其代理商均无任何关系。') }}
          </div>
          <div class="mt-5">Copyright © 2023-2025 All rights reserved.</div>
        </div>
      </div>
      <div class="pb-20 ml-100 flex items-center">
        <img class="mr-5 inline-block leading-none" src="~/assets/images/layouts/beian.png" style="width: 22px" alt="" />
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33070202666841" rel="noreferrer" class='link-hover mr-5' target="_blank">浙公网安备33070202666841号</a> |
        <a href="http://beian.miit.gov.cn/" class='link-hover ml-5' target="_blank">浙ICP备2023043194号</a>
      </div>
    </div>
  </div>
</template>

<script setup>
const showIcp = ref(false)
const { t: $t } = useI18n()
const localePath = useLocalePath()
const mainAttr = ref([
  {
    title: $t('饰品市场'),
    desc: $t('国内外饰品价格比较'),
    img: 'https://cdn.steamdt.com/new-index/footer/mkt.svg',
    link: localePath('/mkt')
  },
  {
    title: $t('饰品追踪'),
    desc: $t('通过磨损值追踪饰品所在库存'),
    img: 'https://cdn.steamdt.com/new-index/footer/tracker.svg',
    link: localePath('/cs2/tracker')
  },
  {
    title: $t('库存估值'),
    desc: $t('支持查询CS2任意日期库存信息'),
    img: 'https://cdn.steamdt.com/new-index/footer/inventory.svg',
    link: localePath('/inventory')
  },
  {
    title: $t('自定义饰品大盘'),
    desc: $t('饰品收藏夹即自定义饰品大盘'),
    img: 'https://cdn.steamdt.com/new-index/footer/collect.svg',
    link: localePath('/my/collect')
  },
  {
    title: $t('饰品DIY'),
    desc: $t('支持武器自定义印花并检视'),
    img: 'https://cdn.steamdt.com/new-index/footer/diy.svg',
    link: localePath('/skindiy')
  }
])
onMounted(() => {
  if (location.hostname === 'steamdt.cn') {
    showIcp.value = true
  }
})
</script>

<style lang="scss" scoped>
@import url('~/assets/styles/_color.scss');

.base-footer {
  .wrapper {
    width: 1400px;
    margin: 0 auto;
  }

  .footer-banner {
    height: 310px;
    background-position: center 20px;
    background-size: contain;
    background-repeat: no-repeat;
    img {
      display: block;
      width: 364px;
      height: 230px;
    }
    .content {
      a {
        &:hover {
          color: #fff;
        }
      }
    }
  }

  .footer-data {
    width: 1400px;
    margin: 0 auto;
    color: $light-gray-color;
    padding: 12px 0;

    .data-left span {
      margin: 0 30px 0 0;
    }

    .data-right span {
      margin: 0 0 0 30px;
    }
  }
}
.link-hover{
 &:hover{
   color: #0252d9
 }
}
</style>
